import { render, staticRenderFns } from "./VCA_UserExperience.vue?vue&type=template&id=6a09f5e6&scoped=true&"
import script from "./VCA_UserExperience.vue?vue&type=script&lang=ts&"
export * from "./VCA_UserExperience.vue?vue&type=script&lang=ts&"
import style0 from "./VCA_UserExperience.vue?vue&type=style&index=0&id=6a09f5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09f5e6",
  null
  
)

export default component.exports